import reactLogo from "./assets/images/logo.png";

function App() {
  const title = process.env.REACT_APP_REPORT_TITLE || 'PANELES ANALYTICS';
  const src = process.env.REACT_APP_REPORT_URL;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
      className="h-100"
    >
      <div
        style={{
          flex: "0",
          display: "flex",
        }}
        className="bg-white"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col">
              <h1
                className="m-0 py-4 text-left"
              >
                {title}
              </h1>
            </div>
            <div className="col-auto">
              <img
                style={{
                  width: 200,
                }}
                className="py-2"
                src={reactLogo}
                alt="logo"
              />
            </div>
          </div>
        </div>
      </div>
      <iframe
        title="ubb_PRESUPUESTO_01_Presupuesto - beta"
        width="100%"
        src={src}
        frameBorder="0"
        allowFullScreen
        style={{ flex: 1 }}
      ></iframe>
    </div>
  );
}

export default App;
